import React, { useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { jsPDF } from "jspdf";
import { LoadingButton } from "@mui/lab";
import PrintIcon from "@mui/icons-material/Print";
import { getApiCall } from "../../../../services/apiHelper";
import { AppraisalReviewServiceURL } from "../../../../config/config";
import { ServiceName } from "../../../../constants";
import { AppraisalAttachment, AuditLog, GetAppraisalModel } from "../../../../all_Interfaces";
import { compileAppraisalDetailsTemplate } from "./compilers/appraisalDetailCompiler";
import { Appraiser } from "../../../../redux/slices/Appraiser1Slice";
import { compileEquityAppraisalValuesTemplate } from "./compilers/equityAppraisalValuesCompiler";
import { compileDadlAppraisalValuesTemplate } from "./compilers/dadlAppraisalValuescompiler";
import { compileCmAppraisalValuesTemplate } from "./compilers/cmAppraisalValuesCompiler";
import { compileEquityAssetTemplate } from "./compilers/equityAssetCompiler";
import { compileOtherAssetTemplate } from "./compilers/otherAssetsCompiler";
import headerLogoBase64 from "./templates/headerlogo";
import { compileHeaderTemplate } from "./compilers/headerCompiler";
import { compileDocumentTemplate } from "./compilers/documentCompiler";
import html2canvas from "html2canvas";
import { AnyARecord } from "dns";
import { compileAuditLogTemplate } from "./compilers/auditCompiler";
import { Button } from "@mui/material";

const PrintToPDF = (props:any) => {
    const [printLoaderButton, setPrintLoaderButton] = useState(false);
    const appraisalData = useAppSelector((state) => state.USAppraisal.data);
    const appraiser1:Appraiser[] = useAppSelector(state => state.Appraiser1List.data);
    const documents:AppraisalAttachment[] = useAppSelector(state => state.UpdateExistingAttachments.data);
    const auditLoggs:AuditLog[] = useAppSelector(state => state.auditLog.data);
    const url = window.location.href;
    const dayjs = require('dayjs');

    const handlePrint = () => {
        setPrintLoaderButton(true);
        generateAppraisalPdf();
      };

      const generateAppraisalPdf = async () => {
        var pdfInstance = new jsPDF("p", "pt");
        var width = pdfInstance.internal.pageSize.getWidth();
        

        const htmlContents = getHtmlContents(appraisalData);
        const pageHeight = pdfInstance.internal.pageSize.getHeight();
        console.log(htmlContents);
        console.log(pageHeight);
        console.log(width);
        addSectionToPdf(htmlContents,pdfInstance,pageHeight,width);
    
      };

  
  

    

      const getHtmlContents = (appraisals:GetAppraisalModel) => {

        var pdfheader = compileHeaderTemplate(appraisals);
        var appraisalDetails = compileAppraisalDetailsTemplate(appraisals,appraiser1);
        const invType = appraisals.investmentType.toLowerCase();
        var appraisalValues:string = "";
        var assets:string = "";
        if(invType === "equity"){
          appraisalValues = compileEquityAppraisalValuesTemplate(appraisals);
        }
        if(invType === "debt asset" || invType === "debt liability"){
          appraisalValues = compileDadlAppraisalValuesTemplate(appraisals);
        }
        if(invType === "mortgage"){
          appraisalValues = compileCmAppraisalValuesTemplate(appraisals);
        }
        if(invType === "debt asset" && appraisals.appraisalType != 'DA'){
          appraisalValues = compileDadlAppraisalValuesTemplate(appraisals);
        }


        var finalString = `${pdfheader}${appraisalDetails}${appraisalValues}`;

        if(invType === "equity"){
          assets = compileEquityAssetTemplate(appraisals);
        }
        else{
          assets = compileOtherAssetTemplate(appraisals);
        }
        if(assets.length){
          finalString = finalString + `${assets}`;
        }
        
        var document = compileDocumentTemplate(documents);
        finalString = finalString + `${document}`;
        

        var auditLogs = compileAuditLogTemplate(auditLoggs,appraisals);
        finalString = finalString + `${auditLogs}`;
        
        return finalString;
      }


    const addSectionToPdf = (
        htmlContents:any,
        pdfInstance:any,
        pageHeight:any,
        width:any
      ) => {
        pdfInstance.html(htmlContents, {
          callback: (doc:any) => {
              generateFinalPdf(doc);
          },
          x: 0,
          y:0,
          autoPaging: "true",
          width: width - (margins.left + margins.right), //target width in the PDF document
          windowWidth: width, //window width in CSS pixels
          margin: Object.values(margins),
        });
      };
    
    

      const getPositionY = (numberOfPages: number, pageHeight: number) => {
        console.log(numberOfPages, pageHeight);
        const positionY =
          (numberOfPages - 1) * (pageHeight - (margins.top + margins.bottom));
        console.log(positionY);
        return positionY;
      };

    const margins = { top: 70, right: 40, bottom: 40, left: 40 };


    const generateFinalPdf = (finalDoc:any) => {
        addHeaderFooters(finalDoc);
        finalDoc.save(getPdfFileName());
        setPrintLoaderButton(false);
      };

    const getPdfFileName = () => {

      var name = "NVH Appraisal Form " + appraisalData.investmentId + " - " + appraisalData.investmentName ;
      const date = new Date(appraisalData.valueDate);
      name = name + " " + dayjs(date.toLocaleString(), 'M/D/YYYY, h:mm:ss A').format("MMM-DD-YYYY") + ".pdf";
      return name;
    };


      const addHeaderFooters = (doc:any) => {
        const pageCount = doc.internal.getNumberOfPages();
        console.log(doc.internal.pageSize.width, doc.internal.pageSize.height);
        for (var i = 1; i <= pageCount; i++) {
          doc.setPage(i);
          addHeader(doc);
          doc.setFontSize(8);
          doc.setTextColor("black");
          doc.text(
            url,
            doc.internal.pageSize.width / 2,
            808,
            { align: "center" }
          );
          doc.text(
            "Page " + String(i) + " of " + String(pageCount),
            doc.internal.pageSize.width / 2,
            820,
            {
              align: "center",
            }
          );
          // doc.text('HEADER TEMPLATE', doc.internal.pageSize.width / 2, 20, {
          //   align: 'center'
          // });
        }
      };

      const addHeader = (doc:any) => {
        if (headerLogoBase64) {
          doc.addImage(headerLogoBase64, "PNG", margins.left, 10, 80, 40);
        }
        doc.setFontSize(18);
        //doc.setTextColor(0, 0, 255);
        doc.setTextColor("#263746");
        //doc.setFontStyle('normal');
        doc.text(
          `Nuveen Value Hub`,
          doc.internal.pageSize.width / 2,
          25,
          { align: "center" }
        );
        doc.setFontSize(14);
        doc.text(
          `Appraisal Form`,
          doc.internal.pageSize.width / 2,
          45,
          { align: "center" }
        );
        //doc.line(3, 60, doc.internal.pageSize.width - 3, 60); // horizontal line
      };

    return (
      // <Button sx={{textTransform:"none"}}
      //       variant="contained"
      //       sx={{ color: '#263746' }}
      //       size="small"
      //       onMouseLeave={props.leavePrintTogglee}
      //       onClick={handlePrint}
      //     >
      //       Print to PDF
      //     </Button>
      <>
        {/* <PrintIcon fontSize="small" color="action" onClick={handlePrint}/> <span>&nbsp;Print To PDF</span> */}
        {!printLoaderButton ? (
          <Button sx={{textTransform:"none",color:'#3f51b5'}}
            variant="text"
            onClick={handlePrint}
            startIcon={<PrintIcon fontSize="small" color="action" />}
          >
            Print To PDF
          </Button>
        ) : (
          <LoadingButton
            loading
            loadingPosition="start"
            startIcon={<PrintIcon fontSize="small" color="action" />}
            variant="text"
          >
            Print To PDF
          </LoadingButton>
        )}
      </>
    );
}

export default PrintToPDF;
